import styled from '@emotion/styled'
import { FormControl, Box, Typography, Chip } from '@mui/material'
import { colors } from '../../../../Themes/Colors'

export const SelectFormControl = styled(FormControl)`
  min-width: 200px;

  .MuiOutlinedInput-root {
    background-color: white;
  }
`

export const SelectAdornment = styled(Box)`
  margin-left: -4px;
`

export const SearchIconStyled = styled(Box)`
  color: ${colors.mediumGrey};
  font-size: 20px;
`

export const FilterLabelContainer = styled(Box)`
  display: flex;
  align-items: center;
  margin-right: 16px;
`

export const FilterLabel = styled(Typography)`
  color: ${colors.mediumGrey};
`

export const ClearAllChip = styled(Chip)`
  margin-left: 8px;
`
